import classNames from 'classnames';
import { useLingui } from '@lingui/react/macro';
import UDFormLabel from 'ud-form/components/label';
import UDButton from 'ud-ui/components/button';

interface Props {
  showDeleteButton?: boolean;
}

function InfoFormSkeleton(props: Props) {
  const { t } = useLingui();
  const { showDeleteButton = false } = props;

  return (
    <div className="mb-5 w-full gap-6 px-6">
      <div className="w-1/2">
        <ItemSkeleton label={t`Название турнира`} className="mb-5" />
        <div className="flex w-full gap-6">
          <ItemSkeleton label={t`Начало турнира`} className="mb-5" />
          <ItemSkeleton label={t`Окончание турнира`} className="mb-5" />
        </div>
        <ItemSkeleton label={t`Тип турнира`} className="mb-5" />
        <ItemSkeleton label={t`Места проведения`} className="mb-5" />
        <ItemSkeleton label={t`Шаблоны`} className="mb-5" />
        <ItemSkeleton label={t`Описание`} className="mb-5" height="58px" />

        <div className="flex gap-6">
          <UDButton variant="primary" type="button" disabled className="w-full" style={{ cursor: 'not-allowed' }}>
            {t`Сохранить`}
          </UDButton>

          {showDeleteButton && (
            <UDButton
              variant="secondary"
              type="button"
              disabled
              style={{
                color: 'lightcoral',
                outline: 'none',
                cursor: 'not-allowed',
              }}
              className="w-full"
            >
              {t`Удалить`}
            </UDButton>
          )}
        </div>
      </div>
    </div>
  );
}

export default InfoFormSkeleton;

interface ItemSkeletonProps {
  label: string;
  className?: string;
  height?: string;
}

const ItemSkeleton = (props: ItemSkeletonProps) => {
  return (
    <div className={classNames('flex w-full flex-col', props.className)}>
      <UDFormLabel className="mb-2">{props.label}</UDFormLabel>
      <div className="skeleton-block w-full" style={{ height: props.height || '38px' }} />
    </div>
  );
};
